/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';
import 'bootstrap-touchspin';
import './lib/slick.min';
import './lib/jquery.hoverIntent.min';
import SlickSlider from './components/slick';
import LazyLoad from './lib/lazyload.min';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import Form from './components/form';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';


import './components/block-cart';
// import Vue from 'vue/dist/vue';
// window.Vue = Vue;
import lazysizes from 'lazysizes'


// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  const form = new Form();
  let slickSlider = new SlickSlider();
  let topMenuEl = $('#_desktop_top_menu #top-menu');
  let topMenu = new TopMenu(topMenuEl);

  form.init();
  slickSlider.init();
  topMenu.init();

    var lazyLoadInstance = new LazyLoad();

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    });

    $("#ScrToTop").hide(); // hide scroll to top button on page load

    $('#ScrToTop').on('click', function () {
        $('html, body').animate({scrollTop: '0px'}, 300);
        $(this).fadeOut("fast");
    });

    $(window).bind('scroll', function(){
        if($(this).scrollTop() > 200) { // show scroll to top button after 200 px of user scrolling
            $("#ScrToTop").slideDown("fast");
        } else {
            $("#ScrToTop").fadeOut("fast");
        }
    });

  if ($('.add-stick').length > 0) {
      var stickOffset = $('.add-stick').offset().top;
      var stickHeight = $('.add-stick').height();
      $(window).scroll(function () {
          var scrollYpos = $(document).scrollTop();
          if (scrollYpos > stickOffset) {
              $(".add-stick").addClass('fixed-top');
              $("body").css('margin-top', stickHeight + 'px');
          } else {
              $(".add-stick").removeClass('fixed-top');
              $("body").css('margin-top', '0');
          }
      });
  }

  $('#menu-icon').on('click', function () {
     $('.ets_mm_megamenu').fadeToggle(500);
  });

  //display input file content in custom file input BS
  $('.custom-file-input').on('change',function(){
      let fileName = $(this).val().split('\\').pop();
      $(this).next('.custom-file-label').addClass("selected").html(fileName);
  });

    if ((typeof elTabsTheme6 !== 'undefined') && elTabsTheme6 === true) {
        $('.elTabsCollapser').on('click', function () {
            setTimeout(function () {
                if ($('.last-card .collapse').hasClass('show')) {
                    $('.last-card-header').addClass('no-radius');
                } else {
                    $('.last-card-header').removeClass('no-radius');
                }
            }, 300);
        });
    }

    if ((typeof elProductTabsTheme6 !== 'undefined') && elProductTabsTheme6 === true) {
        $('.elproducttabs-container-collapse .elTabsCollapseContainer:last-child').children('.card-header').addClass('last-card-header');
        $('.elProductTabsCollapser').on('click', function () {
            setTimeout(function () {
                if ($('.last-card .collapse').hasClass('show')) {
                    $('.last-card-header').addClass('no-radius');
                } else {
                    $('.last-card-header').removeClass('no-radius');
                }
            }, 300);
        });
    }

    var modernCatIMG = $('.modern-category').attr('data-cat-img');
    //$('.modern-category:after').css('background-image', 'url("'+modernCatIMG+'")');
    $('head').append('<style>.modern-category:after{background-image: url('+modernCatIMG+');}</style>');

    $(".iSlideshow").on("beforeChange", function() {
        if (el_img_anim !== 'none') {
            $(".iSlideshow .slick-slide img").removeClass('animate__animated animate__'+el_img_anim+' animate__slow').hide();
        }
        if (el_cap_anim !== 'none') {
            $(".iSlideshow .slick-slide .slider-caption").removeClass('animate__animated animate__'+el_cap_anim+' animate__slow').hide();
        }
        setTimeout(() => {
            if (el_img_anim !== 'none') {
                $(".iSlideshow .slick-slide img").addClass('animate__animated animate__'+el_img_anim+' animate__slow').show();
            }
            if (el_cap_anim !== 'none') {
                $(".iSlideshow .slick-slide .slider-caption").addClass('animate__animated animate__'+el_cap_anim+' animate__slow').show();
            }

        }, 500);

    })

    $('#category-description').each(function(){
        // Removes category description height limit if it's less that $el_catdesc_height (category-header.tpl)
        var category_desc_height = $(this).height();
        var category_desc_height_limit = $(this).attr('data-height');
        if ($(this).hasClass('limited-height') && category_desc_height < category_desc_height_limit) {
            $(this).removeClass('limited-height').removeAttr('style');
        }

        // Expand Category description if click on expand when its height is greater that the set limit
        if ($(this).hasClass('limited-height')) {
            // if ($(this).hasClass('expanded')) {
            //     $(this).on('click', function() {
            //         $(this).css('max-height', category_desc_height_limit + 'px');
            //         $(this).removeClass('expanded');
            //     });
            // } else {
            //     $(this).on('click', function() {
            //         $(this).css('max-height', '100%');
            //         $(this).addClass('expanded');
            //     });
            // }
            $(this).on('click', function() {
                $(this).toggleClass('expanded');
            });
        }
    });
});
document.addEventListener('lazyloaded', function(e){
    $(e.target).parent().addClass('rc--lazyload');
});
